import React from 'react';
import ImageTesterView from './components/ImageTesterView';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <main className="app-main">
        <ImageTesterView />
      </main>
      
      <footer className="app-footer">
        <div className="simple-copyright">
          © 2025 XR Development Toolkit by @itsowaisiqbal
        </div>
      </footer>
    </div>
  );
}

export default App; 